import React from 'react';
import { Link } from 'react-router-dom';

const MODULES = [
  {
    title: 'Find your first build',
    body: 'Scan a Bilt QR on a build at a show, meet, or anywhere you discover one in person.',
  },
  {
    title: 'Attend an event',
    body: 'Log the meets and shows you actually walked — Passport keeps the memory, not a ticket stub.',
  },
  {
    title: 'Follow a hunt',
    body: 'Complete checkpoints and campaigns when they appear at events you care about.',
  },
  {
    title: 'Visit a Bilt shop',
    body: 'Shops and destinations become part of your map of the community.',
  },
] as const;

/**
 * Compelling empty Passport — explains why to scan without looking dead.
 */
export const PassportEmptyExperience: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="rounded-2xl border border-white/[0.1] bg-gradient-to-br from-[#14110c] to-[#0c0c0c] px-5 py-8 sm:px-8">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-200/70">
          Begin
        </p>
        <h2 className="mt-2 text-2xl sm:text-3xl font-semibold text-white tracking-tight">
          Your Passport starts here.
        </h2>
        <p className="mt-3 max-w-lg text-sm text-zinc-400 leading-relaxed">
          Scan Bilt codes at shows, meets, shops, and anywhere you discover a Bilt build. What you
          collect becomes a private history of the cars and places you met in person.
        </p>
        <p className="mt-5 text-sm text-zinc-300">
          Open the Bilt:Spec app and use{' '}
          <span className="font-medium text-white">Scan</span> to log your first encounter.
        </p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none">
        {MODULES.map((m) => (
          <li
            key={m.title}
            className="rounded-xl border border-white/[0.08] bg-[#0c0c0c] px-4 py-4"
          >
            <p className="text-sm font-semibold text-white">{m.title}</p>
            <p className="mt-1.5 text-xs text-zinc-500 leading-relaxed">{m.body}</p>
          </li>
        ))}
      </ul>

      <div className="flex flex-wrap gap-3 text-sm">
        <Link to="/events" className="btn-secondary btn-sm">
          Browse events
        </Link>
        <Link to="/discover" className="btn-secondary btn-sm">
          Discover builds
        </Link>
      </div>
    </div>
  );
};

export default PassportEmptyExperience;
